import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import React, { useEffect } from "react";
import { Form, useForm } from "../../base/views/useForm";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 1),
  },
}));

const initialAssetValue = {
  assetid: "0",
  assetname: "",
  quantity: "1",
  purchasedate: null,
  expirydate: null,
  vendor: "",
  orderno: "",
};

export default function AssetForm(props) {
  const classes = useStyles();
  const { addOrEdit, recordForEdit } = props;
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm,
  } = useForm(initialAssetValue);

  const { storeid, addAsset, editAsset } = props;

  const validate = (fieldValues = values) => {
    let temp = {};
    if ("assetname" in fieldValues)
      temp.assetname =
        fieldValues.assetname === "" ? "Asset name is required" : "";
    if ("quantity" in fieldValues)
      temp.quantity = fieldValues.quantity <= "0" ? "Invalid quantity" : "";
    if ("vendor" in fieldValues)
      temp.vendor = fieldValues.vendor === "" ? "Vendor is required" : "";
    if ("orderno" in fieldValues)
      temp.orderno = fieldValues.orderno === "" ? "Order no. is required" : "";
    if ("purchasedate" in fieldValues)
      temp.purchasedate =
        fieldValues.purchasedate === null ? "Purchase Date is required" : "";
    if ("expirydate" in fieldValues)
      temp.expirydate =
        fieldValues.expirydate === null ? "Expiry Date is required" : "";
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    if (recordForEdit != null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit, setValues]);

  const handlePurchaseDateChange = (date) => {
    setValues({
      ...values,
      purchasedate: date,
    });
  };

  const handleExpiryDateChange = (date) => {
    setValues({
      ...values,
      expirydate: date,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (values.assetid === "0") addAsset({ ...values, storeid });
      else editAsset({ ...values, storeid });
      addOrEdit(values, resetForm);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container component="main" maxWidth="lg">
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField
                autoFocus
                value={values.assetname}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="assetName"
                label="Asset Name"
                name="assetname"
                autoComplete="assetName"
                {...(errors.assetname && {
                  error: true,
                  helperText: errors.assetname,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={values.quantity}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="qty"
                label="Qty"
                name="quantity"
                autoComplete="qty"
                type="number"
                {...(errors.quantity && {
                  error: true,
                  helperText: errors.quantity,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={values.vendor}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="vendor"
                label="Vendor"
                name="vendor"
                autoComplete="vendor"
                {...(errors.vendor && {
                  error: true,
                  helperText: errors.vendor,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={values.orderno}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="orderNo"
                label="Order No."
                name="orderno"
                autoComplete="orderNo"
                {...(errors.orderno && {
                  error: true,
                  helperText: errors.orderno,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    margin="normal"
                    id="dobPurchaseDate"
                    label="Purchase Date"
                    format="MM/dd/yyyy"
                    autoOk={true}
                    okLabel={""}
                    cancelLabel={""}
                    value={values.purchasedate}
                    onChange={handlePurchaseDateChange}
                    className={classes.submit}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(errors.purchasedate && {
                      error: true,
                      helperText: errors.purchasedate,
                    })}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    margin="normal"
                    id="dobWarrantyExpiryDate"
                    label="Expiry Date"
                    format="MM/dd/yyyy"
                    autoOk={true}
                    okLabel={""}
                    cancelLabel={""}
                    value={values.expirydate}
                    onChange={handleExpiryDateChange}
                    className={classes.submit}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(errors.expirydate && {
                      error: true,
                      helperText: errors.expirydate,
                    })}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              style={{
                width: "20vw",
                backgroundColor: "rgb(22, 177, 255)",
                borderRadius: "0.5rem",
              }}
              type="submit"
            >
              Save
            </Button>
          </div>
        </div>
      </Container>
    </Form>
  );
}
